<template>
  <v-data-table
    :headers="headers"
    :items="logs"
    :items-per-page="page.pageSize"
    :loading="isAppLoading"
    :server-items-length="page.totalElements"
    :page="page.pageIndex"
    :disable-sort="true"
    item-key="id"
    class="elevation-1"
    @pagination="pageChanged"
  >
    <template v-slot:item.courseSchedule="{ item }">{{
      formatDate(item.courseSchedule.start)
    }}</template>

    <template v-slot:item.student="{ item }">{{
      `${item.student.firstName} ${item.student.lastName}`
    }}</template>

    <template v-slot:item.teacher="{ item }">{{
      `${item.teacher.firstName} ${item.teacher.lastName}`
    }}</template>

    <template v-slot:item.topic="{ item }">{{ item.topic.name }}</template>
    <template v-slot:item.comprehension="{ item }"
      >{{ item.comprehension }}/10</template
    >
    <template v-slot:item.participation="{ item }"
      >{{ item.participation }}/10</template
    >
    <template v-slot:item.motivation="{ item }"
      >{{ item.motivation }}/10</template
    >
    <template v-slot:item.comments="{ item }">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>mdi-comment-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ item.comments }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  props: {
    courseId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    logs: [],
    page: {
      pageIndex: 1,
      pageSize: 20,
      totalElements: 0,
    },
    headers: [
      {
        text: "Session",
        value: "courseSchedule",
        align: "start",
        sortable: true,
      },
      {
        text: "Student",
        value: "student",
        align: "start",
        sortable: true,
      },
      {
        text: "Teacher",
        value: "teacher",
        align: "start",
        sortable: true,
      },
      {
        text: "Topic",
        value: "topic",
        align: "start",
        sortable: true,
      },
      {
        text: "Comprehension",
        value: "comprehension",
        align: "start",
        sortable: true,
      },
      {
        text: "Motivation",
        value: "motivation",
        align: "start",
        sortable: true,
      },
      {
        text: "Participation",
        value: "participation",
        align: "start",
        sortable: true,
      },
      {
        text: "Comments",
        value: "comments",
        align: "start",
        sortable: true,
      },
    ],
  }),
  computed: {
    ...mapGetters(["isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage", "addMessage", "addSuccessMessage"]),
    formatDate(dateString) {
      return moment(dateString).format("dddd, MMM DD yyyy");
    },
    loadCommunicationLogs() {
      const data = {
        courseIds: [this.courseId],
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
      };
      this.$axios.post("/course/communication/search", data).then((resp) => {
        console.log(resp);
        this.logs = resp.data.data.content;
        this.page.totalElements = resp.data.data.totalElements;
      });
    },
    pageChanged(pagination) {
      this.page.pageIndex = pagination.page;
      this.page.pageSize = pagination.itemsPerPage;
      this.loadCommunicationLogs();
    },
  },
  mounted() {
    this.loadCommunicationLogs();
  },
};
</script>

<style>
</style>